export function ConsultationDetailSkeleton() {
  return (
    <div className="flex w-full animate-pulse flex-col gap-6" aria-hidden="true">
      {/* Back button */}
      <div className="h-4 w-20 rounded bg-gray-200" />

      {/* Header */}
      <div className="flex flex-col gap-2 border-b border-gray-200 pb-4">
        <div className="h-7 w-56 rounded bg-gray-200" />
        <div className="h-4 w-40 rounded bg-gray-200" />
      </div>

      {/* Consultation info card */}
      <div className="rounded-lg bg-white p-5 shadow-sm">
        <div className="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2">
          {Array.from({ length: 6 }).map((_, idx) => (
            <div key={idx} className="space-y-2">
              <div className="h-3 w-20 rounded bg-gray-200" />
              <div className="h-4 w-32 rounded bg-gray-200" />
            </div>
          ))}
        </div>
      </div>

      {/* Documents */}
      <div className="space-y-2">
        <div className="h-5 w-32 rounded bg-gray-200" />
        <div className="rounded-lg bg-white p-5 shadow-sm">
          <div className="flex flex-wrap gap-4">
            {Array.from({ length: 3 }).map((_, idx) => (
              <div key={idx} className="h-36 w-52 rounded-lg bg-gray-100" />
            ))}
          </div>
        </div>
      </div>

      {/* Vital signs */}
      <div className="space-y-2">
        <div className="h-5 w-28 rounded bg-gray-200" />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="space-y-3 rounded-lg bg-white p-6 shadow-sm">
              <div className="h-3 w-24 rounded bg-gray-200" />
              <div className="h-8 w-16 rounded bg-gray-200" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
